import comp from "./ValueComponentWithIcon";
export default comp;
